var _ellipse, _ellipse2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2105,
    cy: 8.22579,
    rx: 3.34675,
    ry: 3.22579,
    fill: "#181A1B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.78943,
    cy: 8.22579,
    rx: 3.34675,
    ry: 3.22579,
    fill: "#181A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78856 18.2907H3.1528C2.51586 18.2907 2 17.7586 2 17.1042C2 15.8947 2.38602 14.6584 3.35107 13.9752C4.5723 13.1141 6.34274 13.0107 7.78856 13.0299C9.23614 13.0088 11.0066 13.1141 12.2278 13.9752C13.1929 14.6565 13.5789 15.8928 13.5789 17.1042C13.5789 17.7586 13.063 18.2907 12.4261 18.2907H7.79032H7.78856Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5444 18.2907H16.2096H16.2114H20.8471C21.4841 18.2907 21.9999 17.7587 21.9999 17.1042C21.9999 15.8928 21.6139 14.6566 20.6488 13.9753C19.4276 13.1141 17.6572 13.0089 16.2096 13.0299C15.2602 13.0174 14.1709 13.0576 13.189 13.3305C14.2188 14.2901 14.6316 16.0032 14.6316 17.6822C14.6316 17.8969 14.6007 18.1022 14.5444 18.2907Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.467c98d9490b4962203eb485ed223301.svg";
export { ForwardRef as ReactComponent };